import React from 'react';
import CheckIcon from '/fallbacks/check.svg';
import parse from 'html-react-parser';

const Checkbox = ({ link, name, error, value, handleChange }) => {
	const checkboxText = window.msg.tr_terms_conditions_checkbox_text;
	return (
		<section className="policy" name="policy">
			<div className="policy__checkbox">
				<input
					className="policy__input"
					checked={value}
					type="checkbox"
					id={name}
					name={name}
					onChange={handleChange}
				/>
				<label name={name} className="policy__label" htmlFor="policy">
					{parse(checkboxText)}
				</label>
				{error && (
					<div style={{ gridRow: '2/3', gridColumn: '1/3' }} className="policyError">
						{error}
					</div>
				)}
				<label name={name} htmlFor={name} className="policy__check">
					<span style={{ backgroundImage: `url(${CheckIcon})` }}></span>
				</label>
			</div>
		</section>
	);
};

export default Checkbox;
